/**
 * Post-pago unificado (por defecto `/muchas-gracias`; override con `VITE_MUCHAS_GRACIAS_SUCCESS_PATH`).
 *
 * - Stripe: `buildStripeSuccessReturnUrl(origin)` → `session_id={CHECKOUT_SESSION_ID}&provider=stripe`.
 *   La página `PremiumInviteSuccess` valida con `/api/validate-payment` y muestra el CTA según **basic | standard | vip** (metadata `plan_tier` en Stripe).
 * - MercadoPago: en el panel del plan, misma URL base de retorno `{origin}{getPostPaymentSuccessPath()}`.
 *   Nota: hoy `/api/validate-payment` solo valida identificadores **Stripe** (`cs_` / `pi_`). Si MP vuelve
 *   con `preapproval_id` u otros params, hace falta extender la API o confiar en query `plan=` + flujo propio.
 *
 * Compat: el router también sirve `/invitacion-premium/success` con el mismo componente.
 */
const DEFAULT_SUCCESS_PATH = "/muchas-gracias";

/** Path absoluto en este sitio (empieza con `/`). Config: `VITE_MUCHAS_GRACIAS_SUCCESS_PATH` o `VITE_POST_PAYMENT_SUCCESS_PATH`. */
export function getPostPaymentSuccessPath(): string {
  const raw = (
    import.meta.env.VITE_MUCHAS_GRACIAS_SUCCESS_PATH ||
    import.meta.env.VITE_POST_PAYMENT_SUCCESS_PATH ||
    ""
  )
    .toString()
    .trim();
  if (!raw) return DEFAULT_SUCCESS_PATH;
  const path = raw.startsWith("/") ? raw : `/${raw}`;
  return path.replace(/\/+$/, "") || DEFAULT_SUCCESS_PATH;
}

/**
 * Path + query para `success_url` de Stripe Checkout (relativo al origin).
 * Ej.: `/muchas-gracias?session_id={CHECKOUT_SESSION_ID}&provider=stripe`
 */
export function buildStripeSuccessReturnRelative(): string {
  const p = getPostPaymentSuccessPath();
  const join = p.includes("?") ? "&" : "?";
  return `${p}${join}session_id={CHECKOUT_SESSION_ID}&provider=stripe`;
}

/** URL absoluta lista para enviar a Stripe como `successUrl`. */
export function buildStripeSuccessReturnUrl(origin: string): string {
  const base = origin.replace(/\/+$/, "");
  const rel = buildStripeSuccessReturnRelative();
  return `${base}${rel.startsWith("/") ? rel : `/${rel}`}`;
}
